<template>
  <div class="Locations"></div>
</template>

<script>
export default {
  name: "Locations",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.locations {
  background-image: url("../assets/pic8.png");
}

</style>
